import Swal from "./Swal";
import config from "../config";
import { matches } from "lodash";

/* The purpose of this is to provide a general purpose error reporter. 
 outputs should include:
    crash reporting
    modal (supressable) (dismissable)
    console error / warning
    opsLog
    analytics maybe someday?
    null

 There will be verbosity levels, and user-level configuration.    
*/

const levels = ["info", "warn", "error", "halt"];
export default function ErrorReporter({
  error,
  level = "error",
  title,
  message,
  id,
}) {
  let hideModal =
    config.FF_DANGEROUSLY_HIDE_ERRORS ||
    config.errorReporting.hideMatching?.find((e) => {
      return matches(e)(error);
    });
  console[level]?.(error);
  if (
    levels.indexOf(level) < levels.indexOf(config.errorReporting.modalLevel)
  ) {
    hideModal = false;
  }
  // user configuration. session-storage.
  if (hideModal) return;
  const swalConfig = {
    title: title || error.name || level,
    text: message || error.message || error,
    icon: "error",
    allowOutsideClick: false,
  };
  if (id) {
    swalConfig.input = "checkbox";
  }
  Swal.fire(swalConfig);
}
